import React, { useEffect, useState } from "react";
import {
  Alert, Box, Button, Card, CircularProgress, Container, Stack,
  TextField, Typography
} from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import GoogleIcon from "@mui/icons-material/Google";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "../supabaseClient.ts";

export const ReviewPage: React.FC = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const reservationId = params.get("reservation") || "";
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [doneText, setDoneText] = useState("");
  const [error, setError] = useState("");
  const googleUrl = process.env.REACT_APP_GOOGLE_REVIEW_URL || "";

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!supabase || !reservationId) {
      setError("Open deze pagina vanuit een eerdere reservering.");
      return;
    }
    setBusy(true); setError("");
    const { data, error: e2 } = await supabase.rpc(
      "customer_submit_review_v1",
      { p_reservation_id: reservationId, p_review_text: text }
    );
    setBusy(false);
    if (e2) {
      setError(e2.message);
      return;
    }
    setDoneText(text);
  }

  async function copy() {
    if (doneText) await navigator.clipboard.writeText(doneText);
  }

  return (
    <Box sx={{ minHeight:"100vh", bgcolor:"#fffafb", py:4 }}>
      <Container maxWidth="sm">
        <Button startIcon={<ArrowBackRoundedIcon />} onClick={() => navigate("/mijn-pippaya/reserveringen")}>
          Terug naar mijn reserveringen
        </Button>
        <Card sx={{ p:3, mt:2 }}>
          <Typography variant="h4">Hoe was het bij Pippaya?</Typography>
          <Typography color="text.secondary" sx={{ mt:1, mb:3 }}>
            Jouw ervaring helpt andere baasjes. De beoordeling verschijnt pas op de website nadat Pippaya hem heeft goedgekeurd.
          </Typography>

          {error && <Alert severity="error" sx={{ mb:2 }}>{error}</Alert>}

          {doneText ? (
            <Stack spacing={2}>
              <Alert severity="success">
                Dank je wel. Je beoordeling staat klaar voor controle door Pippaya.
              </Alert>
              <Typography sx={{ fontStyle:"italic" }}>"{doneText}"</Typography>
              <Button variant="outlined" startIcon={<ContentCopyRoundedIcon />} onClick={copy}>
                Kopieer mijn beoordeling
              </Button>
              {googleUrl && (
                <Button
                  variant="contained"
                  startIcon={<GoogleIcon />}
                  component="a"
                  href={googleUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Deel je ervaring ook op Google
                </Button>
              )}
            </Stack>
          ) : (
            <Box component="form" onSubmit={submit}>
              <TextField
                fullWidth multiline minRows={7}
                label="Jouw beoordeling"
                value={text}
                onChange={(e) => setText(e.target.value)}
                helperText={`${text.length} / 2000 tekens`}
                inputProps={{ maxLength: 2000 }}
                required
              />
              <Button
                type="submit" variant="contained" size="large"
                disabled={busy || text.trim().length < 20}
                sx={{ mt:2 }}
              >
                {busy ? "Versturen..." : "Beoordeling versturen"}
              </Button>
            </Box>
          )}
        </Card>
      </Container>
    </Box>
  );
};
